import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { moduleGet, modulePatch } from "@/common/api/rest/module";

import type { ModuleType, ModulePayloadType } from "@/common/types/module";

import { breadcrumbSimple, svgIcon } from "@/common/components";
import FormModule from "@/components/forms/form-module.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const moduleData = ref<ModuleType | null>(null);

const moduleId = computed(() => route.params.module as string);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "modules",
		label: t("common.labels.modules"),
		url: "/register/module",
	},
	{
		key: "edit",
		label: t("common.labels.edit"),
	},
]);

function fetchData() {
	moduleGet(moduleId.value)
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				moduleData.value = data;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function patchData(payload: Partial<ModulePayloadType>) {
	const newPayload = { ...payload };

	modulePatch(moduleId.value, newPayload)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function back() {
	router.push(`/register/module`);
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "plans",
            size: "2rem"
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" EDITAR MÓDULOS ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FormModule, {
          data: moduleData.value,
          "is-patch": true,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (patchData($event)))
        }, null, 8, ["data"])
      ])
    ])
  ]))
}
}

})